import React, { useEffect, useState } from 'react';
import './Fpv.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { VfrHudMessage } from '../../../utils/MavMessageTypes';

type TelemetryStatProps = {
  receiveTelemetry: boolean;
  voltage: number;
  vfrHud: VfrHudMessage | undefined;
};

const TelemetryStat: React.FC<TelemetryStatProps> = ({ receiveTelemetry, voltage, vfrHud }) => {
  
  const [fresh, setFresh] = useState(false);  
  const [lastUpdate, setLastUpdate] = useState<number>(Date.now());
  const [age, setAge] = useState(0);

  // Когда приходят новые данные — обновляем время последнего обновления
  useEffect(() => {
    if (vfrHud) {
      setLastUpdate(Date.now());
      setFresh(true);
    }
  }, [vfrHud, voltage]);

  // Таймер, который проверяет устарели ли данные
  useEffect(() => {
    const interval = setInterval(() => {
      const currentAge = Date.now() - lastUpdate;
      setAge(currentAge);
      setFresh(currentAge < 1000);
    }, 300);

    return () => clearInterval(interval);
  }, [lastUpdate]);

  return (
    <>
      {receiveTelemetry && (
        <div className='telemetry-stat'>
          
          {/* Индикатор статуса с tooltip */}
          <OverlayTrigger
            placement="left"
            overlay={
              <Tooltip id="tooltip-status">
                {fresh 
                  ? `Данные обновлены ${age} мс назад`
                  : `Нет обновлений уже ${age} мс`
                }
              </Tooltip>
            }
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6, cursor: "pointer" }}>
              <div
                style={{
                  width: 12,
                  height: 12,
                  borderRadius: '50%',
                  backgroundColor: fresh ? 'limegreen' : 'red',
                  marginRight: 6,
                  border: '1px solid black'
                }}
              ></div>
              <span style={{ fontSize: 12 }}>
                {fresh ? "Данные актуальны" : "Нет обновлений"}
              </span>
            </div>
          </OverlayTrigger>

          <div>Напряжение: {voltage.toFixed(2)} V</div>
          <div>Высота: {vfrHud?.alt.toFixed(1)} м</div>
          <div>Курс: {vfrHud?.heading}°</div>
        </div>
      )}
    </>
  );
};

export default TelemetryStat;
